import { Entity } from '@hglobal/common';

export enum SlackWorkspaces {
  RedCore = 'RedCore',
  TWU = 'TWU',
}

export interface AdminSlackChannel extends Entity {
  name: string;
  slackId: string;
  visible: boolean;
  workspace: SlackWorkspaces;
  channelType: SlackChannelTypeEnum;
}

export type SlackMessageChannel = Omit<AdminSlackChannel, 'visible' | 'channelType' | 'workspace'>;

export enum SlackChannelTypeEnum {
  News = 'news',
  Team = 'team',
  Club = 'club',
  Office = 'office',
  Community = 'community',
  Finance = 'finance',
  Messages = 'messages',
  Hr = 'hr',
}
